import { type RequestPolicy } from 'urql';

import { useIsLoggedIn } from '@order/AuthMachine';

import { useHasUnseenChallengesQuery } from './GraphQL/HasUnseenChallenges.generated';

export const useHasUnseenChallenges = (
  requestPolicy: RequestPolicy = 'cache-only',
) => {
  const isLoggedIn = useIsLoggedIn();

  const [response] = useHasUnseenChallengesQuery({
    pause: !isLoggedIn,
    requestPolicy,
  });

  return Boolean(response.data?.hasUnseenChallenges.hasUnseenChallenges);
};
